// // import React, { useState, useEffect } from "react";
// // import { IPDCReportTemplate } from "../../../../components";
// // import { NavLink } from "react-router-dom";
// // import { Add } from "@mui/icons-material";
// // import { Box } from "@mui/material";

// // import useDecodedUser from "../../../../services/hooks/useDecodedUser";

// // import {GetDataFromApiWithParams} from "../../../../services/api/ExecuteApiRequests";

// // export default function AgreementManagementPage() {
// //   const [users, setUsers] = useState([]);
// //   const decodedUser = useDecodedUser();

// //   useEffect(() => {
// //     const fetchUsers = async () => {
// //       const response = await GetDataFromApiWithParams("agreements");
// //       setUsers(response);
// //     };

// //     fetchUsers();
// //   }, []);

// //   return (
// //     <>
// //       <Box pl={2}>
// //         {decodedUser?.role !== "head" && (
// //           <NavLink style={{ position: "relative" }} to="/registerAgreement">
// //             <Add /> Add new agreement
// //           </NavLink>
// //         )}
// //       </Box>
// //       {users && users.length > 0 ? (
// //         <IPDCReportTemplate
// //           title={"System Users"}
// //           data={users}
// //           setData={setUsers}
// //           isPrintable={false}
// //           isEditable={false}
// //           showHeader={false}
// //           isDeletable={false}
// //         />
// //       ) : (
// //         <>{"No Log Data"}</>
// //       )}
// //     </>
// //   );
// // }
// //*************************************** */
// import React, { useState, useEffect } from "react";
// import { IPDCReportTemplate } from "../../../../components";
// import { NavLink } from "react-router-dom";
// import { Add } from "@mui/icons-material";
// import { Box } from "@mui/material";

// import useDecodedUser from "../../../../services/hooks/useDecodedUser";
// import { GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";

// export default function AgreementManagementPage() {
//   const [users, setUsers] = useState([]);
//   const decodedUser = useDecodedUser();

//   useEffect(() => {
//     const fetchUsers = async () => {
//       const response = await GetDataFromApiWithParams("agreements");
      
//       // Transform the data to handle nested objects
//       const transformedData = (response || []).map(item => {
//         // Create a new object with all original properties
//         const transformed = { ...item };
        
//         // Handle shop_details if it exists (could be array or object)
//         if (transformed.shop_details) {
//           if (Array.isArray(transformed.shop_details)) {
//             transformed.shop_details = transformed.shop_details.length > 0 
//               ? `Shops: ${transformed.shop_details.length}` 
//               : '';
//           } else if (typeof transformed.shop_details === 'object') {
//             transformed.shop_details = 'Shop details available';
//           }
//         }
        
//         // Handle room_details if it exists
//         if (transformed.room_details) {
//           if (Array.isArray(transformed.room_details)) {
//             transformed.room_details = transformed.room_details.length > 0 
//               ? `Rooms: ${transformed.room_details.length}` 
//               : '';
//           } else if (typeof transformed.room_details === 'object') {
//             transformed.room_details = 'Room details available';
//           }
//         }
        
//         // Handle any other potential object fields that might be in your data
//         // Add more fields as needed based on your data structure
//         const objectFields = ['linkage', 'late_charge_fee', 'market_destination', 'intl_brands_link'];
//         objectFields.forEach(field => {
//           if (transformed[field] && typeof transformed[field] === 'object') {
//             transformed[field] = JSON.stringify(transformed[field]);
//           }
//         });
        
//         return transformed;
//       });
      
//       setUsers(transformedData);
//     };

//     fetchUsers();
//   }, []);

//   return (
//     <>
//       <Box pl={2}>
//         {decodedUser?.role !== "head" && (
//           <NavLink style={{ position: "relative" }} to="/registerAgreement">
//             <Add /> Add new agreement
//           </NavLink>
//         )}
//       </Box>
//       {users && users.length > 0 ? (
//         <IPDCReportTemplate
//           title={"System Users"}
//           data={users}
//           setData={setUsers}
//           isPrintable={false}
//           isEditable={false}
//           showHeader={false}
//           isDeletable={false}
//         />
//       ) : (
//         <>{"No Log Data"}</>
//       )}
//     </>
//   );
// }
//*******************************************Expor and Print option added */
import React, { useState, useEffect, useRef } from "react";
import { IPDCReportTemplate } from "../../../../components";
import { NavLink } from "react-router-dom";
import { Add, TableChart } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import * as XLSX from "xlsx";

import useDecodedUser from "../../../../services/hooks/useDecodedUser";
import { GetDataFromApiWithParams } from "../../../../services/api/ExecuteApiRequests";

export default function AgreementManagementPage() {
  const [users, setUsers] = useState([]);
  const decodedUser = useDecodedUser();
  const tableRef = useRef(null);

  useEffect(() => {
    const fetchUsers = async () => {
      const response = await GetDataFromApiWithParams("agreements");
      
      // Transform the data to handle nested objects
      const transformedData = (response || []).map(item => {
        // Create a new object with all original properties
        const transformed = { ...item };
        
        // Handle shop_details if it exists (could be array or object)
        if (transformed.shop_details) {
          if (Array.isArray(transformed.shop_details)) {
            transformed.shop_details = transformed.shop_details.length > 0 
              ? `Shops: ${transformed.shop_details.length}` 
              : '';
          } else if (typeof transformed.shop_details === 'object') {
            transformed.shop_details = 'Shop details available';
          }
        }
        
        // Handle room_details if it exists
        if (transformed.room_details) {
          if (Array.isArray(transformed.room_details)) {
            transformed.room_details = transformed.room_details.length > 0 
              ? `Rooms: ${transformed.room_details.length}` 
              : '';
          } else if (typeof transformed.room_details === 'object') {
            transformed.room_details = 'Room details available';
          }
        }
        
        // Handle any other potential object fields that might be in your data
        const objectFields = ['linkage', 'late_charge_fee', 'market_destination', 'intl_brands_link'];
        objectFields.forEach(field => {
          if (transformed[field] && typeof transformed[field] === 'object') {
            transformed[field] = JSON.stringify(transformed[field]);
          }
        });
        
        // Truncate description field to 5 characters + "..."
        if (transformed.description !== undefined && transformed.description !== null) {
          const descValue = String(transformed.description);
          transformed.description = descValue.length > 5 ? descValue.substring(0, 5) + '...' : descValue;
        }
        
        // Truncate disposal_method field to 5 characters + "..."
        if (transformed.disposal_method !== undefined && transformed.disposal_method !== null) {
          const disposalValue = String(transformed.disposal_method);
          transformed.disposal_method = disposalValue.length > 5 ? disposalValue.substring(0, 5) + '...' : disposalValue;
        }
        
        return transformed;
      });
      
      // Reorder data to put "park_name" as first column and "company" as second column
      const reorderedData = transformedData.map(item => {
        const reordered = {};
        const keys = Object.keys(item);
        
        // First, add park_name if it exists
        if (item.park_name !== undefined) {
          reordered.park_name = item.park_name;
        }
        
        // Second, add company if it exists
        if (item.company !== undefined) {
          reordered.company = item.company;
        }
        
        // Then add all other keys except park_name and company
        keys.forEach(key => {
          if (key !== 'park_name' && key !== 'company') {
            reordered[key] = item[key];
          }
        });
        
        return reordered;
      });
      
      setUsers(reorderedData);
    };

    fetchUsers();
  }, []);

  // Export to Excel functionality
  const handleExportExcel = () => {
    if (!users || users.length === 0) return;
    
    // Create a clean copy of data for export
    const exportData = users.map(item => {
      const cleanItem = { ...item };
      Object.keys(cleanItem).forEach(key => {
        if (cleanItem[key] && typeof cleanItem[key] === 'object') {
          cleanItem[key] = JSON.stringify(cleanItem[key]);
        }
      });
      return cleanItem;
    });
    
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Agreements");
    XLSX.writeFile(wb, "agreements_data.xlsx");
  };

  return (
    <>
      <Box pl={2} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
        <Box>
          {decodedUser?.role !== "head" && (
            <NavLink style={{ position: "relative" }} to="/registerAgreement">
              <Add /> Add new agreement
            </NavLink>
          )}
        </Box>
      </Box>
      {users && users.length > 0 ? (
        <>
          <Box display="flex" justifyContent="flex-end" pr={2} mb={1}>
            <Button 
              variant="contained" 
              size="small" 
              startIcon={<TableChart />}
              onClick={handleExportExcel}
              color="primary"
            >
              Export to Excel
            </Button>
          </Box>
          <IPDCReportTemplate
            title={"System Users"}
            data={users}
            setData={setUsers}
            isPrintable={false}
            isEditable={false}
            showHeader={false}
            isDeletable={false}
            ref={tableRef}
          />
        </>
      ) : (
        <>{"No Log Data"}</>
      )}
    </>
  );
}
